// ============================================================
// TESTE DISC — Análise Comportamental
// 24 afirmações em escala Likert (1-5)
// 6 afirmações por fator: D, I, S, C
// Baseado no modelo DISC com formato Likert para scores
// independentes por fator (sem dependência forced-choice)
// ============================================================

export const LIKERT_OPTIONS = [
  { value: 1, label: "Discordo totalmente" },
  { value: 2, label: "Discordo" },
  { value: 3, label: "Neutro" },
  { value: 4, label: "Concordo" },
  { value: 5, label: "Concordo totalmente" },
];

export const QUESTIONS = [
  // ── Dominância (D) ───────────────────────────────────────
  {
    id: "d_01",
    text: "Eu tomo decisões rapidamente, mesmo com informações incompletas.",
    factor: "D",
  },
  {
    id: "d_02",
    text: "Prefiro liderar a seguir instruções de outros.",
    factor: "D",
  },
  {
    id: "d_03",
    text: "Sou direto(a) ao comunicar o que penso, sem rodeios.",
    factor: "D",
  },
  {
    id: "d_04",
    text: "Gosto de desafios e metas ambiciosas.",
    factor: "D",
  },
  {
    id: "d_05",
    text: "Em situações de conflito, prefiro confrontar diretamente.",
    factor: "D",
  },
  {
    id: "d_06",
    text: "Fico impaciente quando as coisas demoram a acontecer.",
    factor: "D",
  },

  // ── Influência (I) ──────────────────────────────────────
  {
    id: "i_01",
    text: "Gosto de conhecer pessoas novas e criar conexões.",
    factor: "I",
  },
  {
    id: "i_02",
    text: "Costumo usar entusiasmo e energia para engajar os outros.",
    factor: "I",
  },
  {
    id: "i_03",
    text: "Prefiro trabalhar em grupo do que sozinho(a).",
    factor: "I",
  },
  {
    id: "i_04",
    text: "As pessoas me descrevem como comunicativo(a) e expressivo(a).",
    factor: "I",
  },
  {
    id: "i_05",
    text: "Tenho facilidade em convencer os outros sobre minhas ideias.",
    factor: "I",
  },
  {
    id: "i_06",
    text: "Fico energizado(a) em ambientes sociais e colaborativos.",
    factor: "I",
  },

  // ── Estabilidade (S) ────────────────────────────────────
  {
    id: "s_01",
    text: "Prefiro ambientes de trabalho com rotina e previsibilidade.",
    factor: "S",
  },
  {
    id: "s_02",
    text: "Sou paciente e evito tomar decisões por impulso.",
    factor: "S",
  },
  {
    id: "s_03",
    text: "Valorizo relações de longo prazo e lealdade.",
    factor: "S",
  },
  {
    id: "s_04",
    text: "Tenho dificuldade em lidar com mudanças bruscas.",
    factor: "S",
  },
  {
    id: "s_05",
    text: "Costumo priorizar a harmonia do grupo acima da minha opinião.",
    factor: "S",
  },
  {
    id: "s_06",
    text: "Prefiro concluir uma tarefa antes de iniciar outra.",
    factor: "S",
  },

  // ── Conformidade (C) ────────────────────────────────────
  {
    id: "c_01",
    text: "Analiso todos os dados disponíveis antes de tomar uma decisão.",
    factor: "C",
  },
  {
    id: "c_02",
    text: "Sou detalhista e me incomodo com erros.",
    factor: "C",
  },
  {
    id: "c_03",
    text: "Prefiro seguir processos bem definidos.",
    factor: "C",
  },
  {
    id: "c_04",
    text: "Questiono informações até ter certeza de que estão corretas.",
    factor: "C",
  },
  {
    id: "c_05",
    text: "Valorizo qualidade acima de velocidade.",
    factor: "C",
  },
  {
    id: "c_06",
    text: "Gosto de planejar com antecedência e evitar improvisação.",
    factor: "C",
  },
];
